import { Badge, BadgeProps, Box, ClickAwayListener, Divider, Grow, ListItem, Popper, Typography, styled } from '@mui/material';
import MuiList from '@mui/material/List';
import MuiPaper from '@mui/material/Paper';
import React, { useRef, useState } from 'react';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Message } from '../../../context/OrderContext';
import { useStyles } from './styles';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LANG_TEXT } from '../../../constants/language';

const Paper = styled(MuiPaper)({
  transformOrigin: 'top left',
  backgroundImage: 'none',
  border: '1px solid',
  borderColor: '#EAECF0',
  boxShadow: `0px 4px 20px rgba(170, 180, 190, 0.3)`,
  marginTop: '2px',
});

const List = styled(MuiList)(({ theme }) => ({
  width: 200,
  maxHeight: 240,
  overflow: 'auto',
  padding: '2px 0',
}));

const Item = styled(ListItem)(({ theme }) => ({
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#EAECF0',
  },
}));

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -10,
    top: -5,
    background: '#B42318',
  },
}));

const Notifications = ({ notifications, markAsRead }: { notifications: Message[]; markAsRead: () => void }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);
  const classes = useStyles();
  const navigate = useNavigate();

  const handleToggle = () => {
    if (!open) {
      markAsRead();
    }
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <>
      <Box ref={anchorRef} className={classes.BoxNotifications} onClick={handleToggle}>
        <StyledBadge badgeContent={notifications?.filter((i) => i.isUnread).length}>
          <NotificationsIcon style={{ color: 'rgba(102, 112, 133, 1)', fontSize: 22 }} />
        </StyledBadge>
      </Box>
      <Popper id="notifications-popup" sx={{ zIndex: 1000 }} anchorEl={anchorRef.current} open={open} placement="bottom-end" transition disablePortal role={undefined}>
        {({ TransitionProps }) => (
          <ClickAwayListener
            onClickAway={() => {
              setOpen(false);
            }}
          >
            <Grow in={open} {...TransitionProps}>
              <Paper>
                <List>
                  {notifications?.length ? (
                    notifications.map((message, index) => (
                      <React.Fragment key={`message-${index}`}>
                        <Item
                          alignItems="flex-start"
                          onClick={() => {
                            navigate(`/dashboard?id=${message.id}`);
                            setOpen((prevOpen) => !prevOpen);
                          }}
                        >
                          <Typography fontSize={14}>
                            {t(LANG_TEXT.NOTIFICATION_NEW_ORDER_MESSAGE, {
                              id: message.id,
                            })}
                          </Typography>
                        </Item>
                        {index < notifications.length - 1 ? <Divider /> : null}
                      </React.Fragment>
                    ))
                  ) : (
                    <Box marginY="10px">
                      <Typography fontSize={14} textAlign="center">
                        {t(LANG_TEXT.NOTIFICATION_EMPTY_STATE)}
                      </Typography>
                    </Box>
                  )}
                </List>
              </Paper>
            </Grow>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );
};

export default Notifications;
